import { DesktopForgotPasswordPage } from '@/app/pages/DesktopForgotPasswordPage';

export function ResponsiveForgotPasswordPage() {
  return <DesktopForgotPasswordPage />;
}
